import './styles.scoped.css'
import {useState, useEffect} from 'react'
import {Typography, Button, Modal, IconButton, Checkbox, FormControlLabel, Radio, RadioGroup} from '@mui/material'
import {Close} from '@mui/icons-material'
import {useMobile} from '../../../../hooks'

export default ({open, setOpen, statuses, selectedStatuses, setSelectedStatuses, setSortBy, setSortOrder, mobileReset}) => {
    const [sortBySelection, setSortBySelection] = useState('')
    const {mobile} = useMobile()

    useEffect(() => {
        if (mobile) {
            setSortBySelection('')
        }
    }, [mobile])

    useEffect(() => {
        switch (sortBySelection) {
            case 'a-z':
                setSortBy('first_name')
                setSortOrder('asc')
                break
            case 'z-a':
                setSortBy('first_name')
                setSortOrder('desc')
                break
            case 'date':
                setSortBy('created_at')
                setSortOrder('desc')
                break
            case 'latest':
                setSortBy('updated_at')
                setSortOrder('desc')
                break
            default:
                setSortBy('')
                setSortOrder('')
                break
        }
    }, [sortBySelection])

    const toggleStatus = id => {
        if (id === 'all') {
            if (selectedStatuses.length === statuses.length) {
                setSelectedStatuses([])
            } else {
                setSelectedStatuses(statuses.map(s => s.id))
            }
        } else {
            if (selectedStatuses.includes(id)) {
                setSelectedStatuses(selectedStatuses.filter(s => s !== id))
            } else {
                setSelectedStatuses([...selectedStatuses, id])
            }
        }
    }

    const handleReset = () => {
        mobileReset()
        setSortBySelection('')
    }

    return (
        <Modal open={open}>
            <div className="container">
                <div className="content">
                    <div className="header">
                        <Typography variant="h6" color="text.primary">
                            Filter
                        </Typography>
                        <IconButton onClick={() => setOpen(false)}>
                            <Close />
                        </IconButton>
                    </div>
                    <div className="actions">
                        <Button variant="outlined" onClick={handleReset} style={{flex: 1}}>
                            Reset
                        </Button>
                        <Button variant="contained" onClick={() => setOpen(false)} style={{flex: 1}}>
                            Ok
                        </Button>
                    </div>
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <Typography variant="h7" color="text.primary">
                        Status
                    </Typography>
                    <br />
                    <div className="list">
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={selectedStatuses.length === statuses.length}
                                    indeterminate={selectedStatuses.length > 0 && selectedStatuses.length < statuses.length}
                                    onChange={() => toggleStatus('all')}
                                />
                            }
                            label="Select All"
                        />
                        {statuses.map(s => (
                            <FormControlLabel
                                key={s.id}
                                control={<Checkbox checked={selectedStatuses.includes(s.id)} onChange={() => toggleStatus(s.id)} />}
                                label={s.display_name}
                            />
                        ))}
                    </div>
                    <br />
                    <Typography variant="h7" color="text.primary">
                        Sort By
                    </Typography>
                    <br />
                    <RadioGroup value={sortBySelection || ''} onChange={e => setSortBySelection(e.target.value)}>
                        <FormControlLabel value="a-z" control={<Radio />} label="A–Z" />
                        <FormControlLabel value="z-a" control={<Radio />} label="Z–A" />
                        <FormControlLabel value="date" control={<Radio />} label="Date Added" />
                        <FormControlLabel value="latest" control={<Radio />} label="Latest Active" />
                    </RadioGroup>
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                </div>
            </div>
        </Modal>
    )
}
